import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductionStockToPhysicalStockControllerRequestService } from 'src/app/services/api/sign/stock/production-stock-to-physical-stock/production-stock-to-physical-stock-controller-request.service';

@Component({
  selector: 'production-stock-to-physical-stock-modal',
  templateUrl: './production-stock-to-physical-stock-modal.component.html',
  styleUrls: ['./production-stock-to-physical-stock-modal.component.scss']
})
export class ProductionStockToPhysicalStockComponent {
  @Input()
  signId: number;

  @Input()
  currentProductionStock: number;

  @Output()
  didUpdateStock = new EventEmitter<ProductionStockToPhysicalStockEvent>();

  amountRoof: number = 0;
  amountShelf: number = 0;

  saving: boolean = false;

  constructor(
    private productionStockToPhysicalStockControllerRequestService: ProductionStockToPhysicalStockControllerRequestService
  ) {}

  save(): void {
    this.saving = true;
    const amountRoof = this.amountRoof == null ? 0 : this.amountRoof;
    const amountShelf = this.amountShelf == null ? 0 : this.amountShelf;
    this.productionStockToPhysicalStockControllerRequestService
      .productionStockToPhysicalStock(this.signId, amountRoof, amountShelf)
      .then(() =>
        this.didUpdateStock.emit({
          amountRoof: amountRoof,
          amountShelf: amountShelf
        })
      )
      .finally(() => (this.saving = false));
  }
}

export interface ProductionStockToPhysicalStockEvent {
  amountRoof: number;
  amountShelf: number;
}
